__turbopack_context__.v({
  "OverlapButton": "Chip-module-scss-module__yNsBpG__OverlapButton",
});
